// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".epic-web-esport-site." + "d927da23d25b879af2b7" + ".js";
};